import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FireflyEditableChipGroupComponent } from '../editable-chip-group/editable-chip-group.component';

@Component({
  selector: 'f-wide-editable-chip-group',
  templateUrl: '../editable-chip-group/editable-chip-group.component.html',
  styleUrls: ['./wide-editable-chip-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class FireflyWideEditableChipGroupComponent extends FireflyEditableChipGroupComponent implements AfterViewInit {
  @ViewChild('popover') override popover!: NgbPopover;
  ngAfterViewInit(): void {
    if (this.popover) {
      const originalOpen = this.popover.open.bind(this.popover);
      this.popover.open = () => {
        originalOpen();
        const popoverElement = document.querySelector('.popover:last-child');
        if (popoverElement && !popoverElement.classList.contains('f-wide-editable-chip-group-popover')) {
          popoverElement.classList.add('f-wide-editable-chip-group-popover');
        }
      };
    }
  }
}
